import { Paragraph3 } from '@cian/ui-kit';
import * as React from 'react';

import { AgentWorkHonestlyProofs } from '../../../../components/AgentWorkHonestlyProofs';
import { useOfferContext } from '../../../../context';
import { getAgentLevelInfo, getIsUserIdentifiedByDocuments } from './utils';

export const AgentWorkHonestlyProofsContainer = () => {
  const offerData = useOfferContext();
  const levelInfo = getAgentLevelInfo(offerData);
  const isUserIdentifiedByDocuments = getIsUserIdentifiedByDocuments(offerData);
  const { agentInfo } = offerData;

  if (!levelInfo && !isUserIdentifiedByDocuments) {
    return null;
  }

  return (
    <>
      {(levelInfo?.hasVerifiedDocuments || isUserIdentifiedByDocuments) && (
        <AgentWorkHonestlyProofs message="Документы проверены" />
      )}
      {agentInfo && <Paragraph3 color="gray60_100">{agentInfo}</Paragraph3>}
    </>
  );
};
